import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

// sessionStorage に保存する設定
const { persistAtom } = recoilPersist({
  key: 'tableNumber',
  storage: sessionStorage,  // 必要なら localStorage に変更可能
});

export const tableNumberState = atom<Number>({
  key: 'tableNumberState', // ユニークなキー
  default: 1,
  effects_UNSTABLE: [persistAtom], // 永続化設定を適用
});
